<template>
    <div class="animated fadeIn">
        <!-- <loader v-if="loading"></loader> -->
        <div>
            <b-row class="mt-1 dashboard-header">
                <b-col md="9">
                    <p class="dash-text">Dashboard</p>
                </b-col>
                <b-col md="3" class="py-0 dashboard-drop">
                    <eb-select
                        style="background-color: #fff"
                        id="tenantAnalyticReport"
                        type="text"
                        label="text"
                        v-if="$userRole !== 'Admin'"
                        v-model="selectedDate1"
                        :selected="selectedDate1.text"
                        @input="changeDate1"
                        :options="dayRadioOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs1"
                        modalRef="modalRef1"
                        modalId="dateModal1"
                        @customDateRange="findDateResult1"
                    ></c-date>
                </b-col>
            </b-row>
        </div>
        <b-card class="mt-2">
            <b-row v-if="$userRole == 'Admin'">
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Tenants"
                        :value="adminDashboard.tenantCount"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Markets"
                        :value="adminDashboard.totalMarkets"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Users"
                        :value="adminDashboard.totalUsers"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Attributes"
                        :value="adminDashboard.totalAttributes"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Roles"
                        :value="adminDashboard.totalRoles"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Permissions"
                        :value="adminDashboard.totalPermissions"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Features"
                        :value="adminDashboard.totalFeatures"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Subscriptions"
                        :value="adminDashboard.totalSubscriptions"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Business Plan"
                        :value="adminDashboard.totalBusinessPlans"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
            </b-row>
            <b-row v-if="$userRole == 'Tenant'">
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Partners"
                        :value="dashboard.partnerCount"
                        routePath="/partner"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Customers"
                        :value="dashboard.totalCustomers"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Orders"
                        routePath="/manage-orders"
                        :value="dashboard.totalOrders"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Items"
                        :value="dashboard.totalItems"
                        bottomColor="#4caf50"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Order Amount"
                        routePath="/manage-orders"
                        :value="dashboard.totalAmount"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        routePath="/setup/service-request"
                        labelText="No Of SR / Ticket 1 Month"
                        :value="dashboard.totalService"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <!-- TENANT -->
            </b-row>
            <b-row v-if="this.$currentUserData.category == 'SELLER'">
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Orders"
                        routePath="/manage-orders"
                        :value="dashboard.totalOrders"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Order Completed"
                        routePath="/manage-orders"
                        :value="dashboard.totalOrderCompleted"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Cancelled Order"
                        routePath="/manage-orders"
                        :value="dashboard.totalCancelledOrders"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Returned Order"
                        routePath="/manage-orders"
                        :value="dashboard.totalReturnedOrders"
                        bottomColor="#4caf50"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Items"
                        routePath="/item"
                        :value="dashboard.totalItems"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Item Sold Out"
                        :value="dashboard.totalItemSoldOut"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Item Low Stock"
                        :value="dashboard.totalItemLowStock"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Pending Approval"
                        :value="dashboard.totalPendingApproval"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        routePath="/item"
                        labelText="Online Items"
                        :value="dashboard.totalOnlineItems"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        routePath="/item"
                        labelText="Offline Items"
                        :value="dashboard.totalOfflineItems"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        routePath="/manage-orders"
                        labelText="Live Orders"
                        :value="dashboard.totalLiveOrders"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <!-- SELLER -->
            </b-row>
            <b-row
                v-if="
                    this.$currentUserData.category == 'DISTRIBUTOR' ||
                    this.$currentUserData.category == 'DEALER'
                "
            >
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="New/Total Partners"
                        :value="`${distributor.newPartner}/${distributor.totalPartner}`"
                        routePath="/partner"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="New/Total Items"
                        :value="`${distributor.newItems}/${distributor.totalItems}`"
                        bottomColor="#4c4be8"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Order Count"
                        routePath="/manage-orders"
                        :value="distributor.orderCount"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Order Amount"
                        routePath="/manage-orders"
                        :value="`रु ${distributor.orderAmount}`"
                        bottomColor="#4caf50"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Agent"
                        routePath="/user"
                        :value="distributor.totalAgent"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Failed Payment"
                        routePath="/payment-history"
                        :value="distributor.totalFailedPayment"
                        bottomColor="#4c4be8"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Active Seller"
                        routePath="/partner"
                        :value="distributor.totalActiveSeller"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="New seller"
                        :value="distributor.totalNewSeller"
                        bottomColor="#4caf50"
                    ></dashboardInfoCard>
                </b-col>
            </b-row>
        </b-card>
        <b-row
            v-if="
                $userRole == 'Admin' ||
                this.$currentUserData.category == 'SELLER' ||
                $userRole == 'Tenant'
            "
        >
            <b-col md="7" class="pb-0">
                <b-row>
                    <b-col md="3">
                        <p class="head-text">Order Chart</p>
                    </b-col>
                    <b-col md="3"
                        ><ev-select
                            v-if="$userRole == 'Admin'"
                            style="background-color: #fff"
                            id="text"
                            type="text"
                            label="text"
                            placeholder="Select Status"
                            :options="statusOptions"
                            v-model="selectedStatusOptions"
                            :selected="selectedStatusOptions"
                            @input="changeStatus"
                        >
                        </ev-select
                    ></b-col>
                    <b-col md="3">
                        <eb-select
                            v-if="$userRole == 'Admin'"
                            style="background-color: #fff"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedTenant"
                            :selected="selectedTenant.text"
                            @input="changeTenant"
                            :options="tenantList"
                            placeholder="Select a tenant"
                        ></eb-select>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedDate2"
                            :selected="selectedDate2.text"
                            @input="changeDate2"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs2"
                            modalRef="modalRef2"
                            modalId="dateModal2"
                            @customDateRange="findDateResult2"
                        ></c-date>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="5" class="pb-0">
                <b-row>
                    <b-col md="6" v-if="$userRole !== 'Admin'">
                        <p class="head-text">Top Revenue Market</p>
                    </b-col>
                    <b-col md="6" v-if="$userRole == 'Admin'">
                        <eb-select
                            style="background-color: #fff"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedTenant2"
                            :selected="selectedTenant2.text"
                            @input="changeTenant"
                            :options="tenantList"
                            placeholder="Select a tenant"
                        ></eb-select>
                    </b-col>
                    <b-col md="6">
                        <eb-select
                            style="background-color: #fff"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedDate3"
                            :selected="selectedDate3.text"
                            @input="changeDate3"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs3"
                            modalRef="modalRef3"
                            modalId="dateModal3"
                            @customDateRange="findDateResult3"
                        ></c-date>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row
            v-if="
                $userRole == 'Admin' ||
                this.$currentUserData.category == 'SELLER' ||
                $userRole == 'Tenant'
            "
        >
            <b-col md="7">
                <b-card style="border-radius: 16px">
                    <div
                        v-if="
                            barChartData &&
                            barChartData.labels &&
                            barChartData.labels.length
                        "
                    >
                        <BarChart
                            v-if="!isLoading"
                            :chart-data="barChartData"
                            :chart-options="barChartOptions"
                        />
                    </div>
                    <div v-else>
                        <h4 class="text-center no-data-margin">
                            No Data Available
                        </h4>
                    </div>
                </b-card>
            </b-col>
            <b-col md="5">
                <b-card style="border-radius: 16px; height: 100%">
                    <div
                        v-if="
                            getDoughChartData &&
                            getDoughChartData.labels &&
                            getDoughChartData.labels.length
                        "
                    >
                        <Doughnut
                            v-if="!isTopMarketLoading"
                            class="doughnut chart-doughnut"
                            :chart-data="getDoughChartData"
                            :chart-options="chartOptions"
                        >
                        </Doughnut>
                    </div>
                    <div
                        v-else
                        class="d-flex align-items-center"
                        style="height: 100%"
                    >
                        <h4 class="text-center">No Data Available</h4>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Doughnut from "@/components/chart/Doughnut.js";
import tenantDoughnutChart from "@/utils/tenantDoughnutChart";
import ComponentHeader from "@/components/componentNewHeader";
import BarChart from "@/components/chart/BarChart.vue";
import orderDataBarChart from "@/utils/orderDataBarChart";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";
import reportData1 from "@/components/dashboardChart/reportData1.vue";
import reportData2 from "@/components/dashboardChart/reportData2.vue";
import { mapState } from "vuex";
import moment from "moment";
export default {
    name: "dashboard",
    components: {
        ComponentHeader,
        dashboardInfoCard,
        Doughnut,
        BarChart,
        loader,
        ebSelect,
        evSelect,
        cDate,
        reportData1,
        reportData2,
    },
    data: function () {
        return {
            selectedStatusOptions: [],
            statusOptions: [
                "All Status",
                "Delivered",
                "Created",
                "Out For Delivery",
                "Payment Failed",
                "Cancelled",
                "Rejected",
                "Returned",
                "Dispatched",
                "Refund",
                "Delivery Attached",
                "Confirmed",
            ],
            selectedTenant: {
                text: "All Tenants",
                value: 123,
            },
            selectedTenant2: {
                text: "All Tenants",
                value: 123,
            },
            adminDashboard: {
                tenantCount: 0,
                totalMarkets: 0,
                totalUsers: 0,
                totalAttributes: 0,
                totalRoles: 0,
                totalPermissions: 0,
                totalFeatures: 0,
                totalSubscriptions: 0,
                totalBusinessPlans: 0,
            },
            dashboard: {
                partnerCount: 0,
                totalItems: 0,
                totalCustomers: 0,
                totalOrders: 0,
                totalAmount: 0,
                totalService: 0,
                totalAgent: 0,
                totalActiveSeller: 0,
                totalNewSeller: 0,
                totalUpcomingRenewal: 0,
                totalSellerRenewalDue: 0,
                totalFailedPayment: 0,
                totalOrderCompleted: 0,
                totalLiveOrders: 0,
                totalCancelledOrders: 0,
                totalReturnedOrders: 0,
                totalItemSoldOut: 0,
                totalPendingApproval: 0,
                totalOfflineItems: 0,
                totalOnlineItems: 0,
                totalItemLowStock: 0,
            },
            distributor: {
                newPartner: 0,
                totalPartner: 0,
                newItems: 0,
                totalItems: 0,
                orderCount: 0,
                orderAmount: 0,
                totalAgent: 0,
                totalFailedPayment: 0,
                totalActiveSeller: 0,
                totalNewSeller: 0,
            },
            loading: false,
            selectedDate1: {
                text: "Today",
                value: 0,
            },
            selectedDate2: {
                text: "Today",
                value: 0,
            },
            selectedDate3: {
                text: "Today",
                value: 0,
            },
            startDate: "",
            endDate: "",
            isTopMarketLoading: false,
            dayRadioOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 days",
                    value: 6,
                },
                {
                    text: "30 days",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            isLoading: false,
        };
    },
    computed: {
        ...mapState({
            allTenantList: (state) => state.tenant.tenantsList,
        }),
        tenantList() {
            let tenantData = [
                {
                    text: "All Tenants",
                    value: 123,
                },
            ];
            this.allTenantList.forEach((el) => {
                if (el.status == "Active") {
                    let obj = {
                        text: el.authentication.userName,
                        value: el._id,
                    };
                    tenantData.push(obj);
                }
            });
            return tenantData;
        },
        tenantId() {
            let id = "";
            if (
                ["SELLER", "DISTRIBUTOR", "DEALER"].includes(
                    this.$currentUserData.category
                )
            ) {
                id = this.$store.getters["auth/getTenant"];
            }
            return id;
        },
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        chartData() {
            let dataList =
                this.$store.getters["partner/getBulkAnalyticsReport"];
            const labels = [];
            const dataSets = [
                {
                    label: "Order Amount",
                    fill: false,
                    borderColor: "#2554FF",
                    backgroundColor: "#2554FF",
                    pointBorderColor: "#2554FF",
                    borderWidth: 3,
                    data: [],
                },
                {
                    label: "Order Count",
                    fill: false,
                    borderColor: "#FF54FF",
                    backgroundColor: "#FF54FF",
                    pointBorderColor: "#FF54FF",
                    borderWidth: 3,
                    data: [],
                },
            ];
            if (dataList && dataList["total-order-report-graph"]) {
                if (dataList["total-order-report-graph"].length > 0) {
                    dataList["total-order-report-graph"].map((x) => {
                        labels.push(`${x.day}-${x.month}-${x.year}`);
                        dataSets[0].data.push(
                            +parseFloat(x.orderamount).toFixed(2)
                        );
                        dataSets[1].data.push(
                            +parseFloat(x.ordercount).toFixed(2)
                        );
                    });
                }
            }
            return {
                labels,
                dataSets,
            };
        },
        barChartData() {
            let data = this.$store.getters["partner/getBulkAnalyticsReport"];
            let orderkey = "";
            let orderAmount = "";
            let orderCount = "";
            if (this.$userRole == "Tenant") {
                orderkey = "total-order-report-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            if (this.$userRole == "Admin") {
                orderkey = "orderbyvalue-graph";
                if (this.selectedTenant.text === "All Tenants") {
                    orderkey = "all-tenants-orderbyvalue-graph";
                }
                if (this.selectedTenant2.text === "All Tenants") {
                    orderkey = "all-tenants-orderbyvalue-graph";
                }
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            if (this.$currentUserData.category === "SELLER") {
                orderkey = "seller-total-order-report-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            const orderList = data[orderkey];
            return orderDataBarChart(orderList, orderAmount, orderCount);
        },
        barChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            callback: function (value) {
                                const valueLegend =
                                    this.getLabelForValue(value);
                                const valueLegendRep = valueLegend.replaceAll(
                                    ",",
                                    ""
                                );
                                if (Number(valueLegendRep) < 2) {
                                    return valueLegendRep * 10;
                                } else {
                                    const valueShort =
                                        Number(valueLegendRep) / 1000;
                                    return valueShort + " " + "k";
                                }
                            },
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/getBulkAnalyticsReport"
                                    ];

                                let orderReportData = [];
                                if (this.$userRole == "Tenant") {
                                    orderReportData =
                                        data["total-order-report-graph"];
                                }
                                if (
                                    this.$currentUserData.category === "SELLER"
                                ) {
                                    orderReportData =
                                        data["seller-total-order-report-graph"];
                                }
                                if (this.$userRole == "Admin") {
                                    orderReportData =
                                        data["orderbyvalue-graph"];
                                    if (
                                        this.selectedTenant.text ===
                                        "All Tenants"
                                    ) {
                                        orderReportData =
                                            data[
                                                "all-tenants-orderbyvalue-graph"
                                            ];
                                    }
                                }
                                let selctedData = orderReportData.find(
                                    (e) => e.orderamount == tooltipItem.raw
                                );
                                let showTooltip1 = [];
                                showTooltip1.push(
                                    `${selctedData.orderamount}: Order Amount`
                                );
                                showTooltip1.push(
                                    `${selctedData.ordercount}: Order Count`
                                );
                                return showTooltip1;
                            },
                        },
                    },
                },
            };
        },
        chartOptions() {
            return {
                plugins: {
                    legend: {
                        position: "bottom",
                    },
                },
            };
            // hoverBorderWidth: 10,
        },
        getDoughChartData() {
            let dataList = this.$store.getters["partner/getTopMarketChartData"];
            let dataKey = undefined;
            if (this.$userRole == "Tenant") {
                dataKey = "top-revenue-market-report";
            }
            if (this.$currentUserData.category === "SELLER") {
                dataKey = "seller-top-revenue-market-report";
            }
            if (this.$userRole === "Admin") {
                dataKey = "admin-top-revenue-market-report";
            }
            return tenantDoughnutChart(dataList, dataKey);
        },
        deliverChart() {
            let dataList =
                this.$store.getters["partner/getBulkAnalyticsReport"];
            const labels = [];
            const dataSets = [
                {
                    label: "Order Delivery Amount",
                    fill: false,
                    borderColor: "#2554FF",
                    backgroundColor: "#2554FF",
                    pointBorderColor: "#2554FF",
                    borderWidth: 3,
                    data: [],
                },
                {
                    label: "Order Delivery Count",
                    fill: false,
                    borderColor: "#FF54FF",
                    backgroundColor: "#FF54FF",
                    pointBorderColor: "#FF54FF",
                    borderWidth: 3,
                    data: [],
                },
            ];
            if (dataList && dataList["order-delivered-chart"]) {
                if (dataList["order-delivered-chart"].length > 0) {
                    dataList["order-delivered-chart"].map((x) => {
                        labels.push(`${x.month}-${x.year}`);
                        dataSets[0].data.push(
                            +parseFloat(x.totalamount).toFixed(2)
                        );
                        dataSets[1].data.push(
                            +parseFloat(x.totalorders).toFixed(2)
                        );
                    });
                }
            }
            return {
                labels,
                dataSets,
            };
        },
    },
    methods: {
        changeDate1(e) {
            if (e.value == "custom") {
                this.$refs["compRefs1"].openModal();
                return;
            }
            if (this.$userRole == "Tenant") {
                this.getTenantAnalyticsData();
                return;
            }
            if (
                ["DISTRIBUTOR", "DEALER", "SUB_DEALER"].includes(
                    this.$currentUserData.category
                )
            ) {
                this.getDealerDistributorInfo();
            }
            if (this.$currentUserData.category === "SELLER") {
                this.getSellerDashboardInfo();
                return;
            }
        },
        changeTenant(e) {
            this.fetchAdminOrderChart();
        },
        changeStatus(e) {
            if (e.some((el) => el === "All Status")) {
                if (e.indexOf("All Status") === 0 && e.length > 1) {
                    e.splice(e.indexOf("All Status"), 1);
                    this.selectedStatusOptions = e;
                } else {
                    this.selectedStatusOptions = ["All Status"];
                }
            } else {
                this.selectedStatusOptions = e;
            }
            this.fetchAdminOrderChart();
        },
        changeDate2(e) {
            if (e.value == "custom") {
                this.$refs["compRefs2"].openModal();
                return;
            }
            if (this.$userRole == "Tenant") {
                this.fetchTenantOrderChart();
            } else if (this.$userRole == "Admin") {
                this.fetchAdminOrderChart();
            } else {
                this.fetchSellerOrderChart();
            }
        },
        changeDate3(e) {
            if (e.value == "custom") {
                this.$refs["compRefs3"].openModal();
                return;
            }
            if (this.$userRole == "Tenant") {
                this.fetchTopMarketRevenueData();
            } else {
                this.fetchSellerTopMarketRevenue();
            }
        },
        findDateResult1(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            if (this.$userRole == "Tenant") {
                this.getTenantAnalyticsData();
            } else {
                this.getDealerDistributorInfo();
            }
        },
        findDateResult2(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            if (this.$userRole == "Tenant") {
                this.fetchTenantOrderChart();
            }
            if (this.$userRole == "Admin") {
                this.fetchAdminOrderChart();
            } else {
                this.fetchSellerOrderChart();
            }
        },
        findDateResult3(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            if (this.$userRole == "Tenant") {
                this.fetchTopMarketRevenueData();
            } else {
                this.fetchSellerTopMarketRevenue();
            }
        },
        getDateInfo(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (typeof dateData === "number") {
                const data = {
                    fromDate: moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            }
        },
        async getDealerDistributorInfo() {
            let user = this.$currentUserData.category
                .toLowerCase()
                .replace("_", "");
            const itemList = [
                `${user}-total-new-merchant`,
                `${user}-total-orders`,
                `${user}-total-failed-payment`,
                `${user}-total-agents`,
                `${user}-total-new-items`,
                `${user}-total-active-seller`,
                `${user}-total-active-seller`,
            ];
            let items = [];
            let variablesObj = {
                tenant: this.tenantId,
                ...this.getDateInfo(this.selectedDate1.value),
                userId: this.userId,
            };
            itemList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {
                        ...variablesObj,
                    },
                });
            });
            try {
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    {
                        items: items,
                    }
                );
                this.distributor.newPartner =
                    data[`${user}-total-new-merchant`]?.count || 0;
                this.distributor.newItems =
                    data[`${user}-total-new-items`]?.items || 0;
                this.distributor.orderCount =
                    data[`${user}-total-orders`]?.total_order || 0;
                this.distributor.orderAmount =
                    data[`${user}-total-orders`]?.total_order_amount || 0;
                this.distributor.totalAgent =
                    data[`${user}-total-agents`]?.count || 0;
                this.distributor.totalFailedPayment =
                    data[`${user}-total-failed-payment`]?.total_order || 0;
                this.distributor.totalActiveSeller =
                    data[`${user}-total-active-seller`]?.count || 0;
                this.distributor.totalNewSeller =
                    data[`${user}-total-new-merchant`]?.count || 0;
            } catch (error) {
                this.$toasted.error("Data not found!");
            }
        },
        async getSellerDashboardInfo() {
            this.loading = true;
            const keyList = [
                "seller-total-orders",
                "seller-cancelled-orders",
                "seller-item-low-stock",
                "seller-item-outofstock",
                "seller-returned-orders",
                "seller-total-items",
                "seller-completed-orders",
                "seller-online-items",
                "seller-offline-items",
                "seller-pending-orders",
            ];
            let variablesObj = {
                ...this.getDateInfo(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.tenantId,
            };
            let items = [];
            keyList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {
                        ...variablesObj,
                    },
                });
            });
            items.push({
                key: "seller-live-order",
                variables: {
                    userId: this.userId,
                    Date: moment().format("YYYY-MM-DD"),
                },
            });
            const data = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                {
                    items: items,
                }
            );

            try {
                this.dashboard.totalOrders =
                    data["seller-total-orders"]["total_order"];
                this.dashboard.totalCancelledOrders =
                    data["seller-cancelled-orders"]["total_order"];
                this.dashboard.totalReturnedOrders =
                    data["seller-returned-orders"]["total_order"];
                this.dashboard.totalOrderCompleted =
                    data["seller-completed-orders"]["total_order"];
                this.dashboard.totalItems = data["seller-total-items"].items;
                this.dashboard.totalOfflineItems =
                    data["seller-offline-items"].items;
                this.dashboard.totalPendingApproval =
                    data["seller-pending-orders"]["total_order"];
                this.dashboard.totalItemLowStock =
                    data["seller-item-low-stock"]["low_stock"];
                this.dashboard.totalItemSoldOut =
                    data["seller-item-outofstock"].outofstock;
                this.dashboard.totalOnlineItems =
                    data["seller-online-items"].items;
                this.dashboard.totalLiveOrders =
                    data["seller-live-order"]["order_count"];
            } catch (err) {
                this.$toasted.error("Data not found!");
            } finally {
                this.loading = false;
            }
        },
        async getTenantAnalyticsData() {
            this.isLoading = true;
            const keyList = [
                "total-partners",
                "total-items",
                "total-customers",
                "total-orders",
                "total-servicerequests",
            ];
            let variablesObj = {
                tenant: this.userId,
                ...this.getDateInfo(this.selectedDate1.value),
            };
            let items = [];
            keyList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {
                        ...variablesObj,
                    },
                });
            });

            await this.$store
                .dispatch("partner/fetchBulkAnalyticReport", { items: items })
                .then((data) => {
                    this.dashboard.partnerCount =
                        data["total-partners"][0].count;
                    this.dashboard.totalItems = data["total-items"].items;
                    this.dashboard.totalCustomers =
                        data["total-customers"].total_customer;
                    this.dashboard.totalOrders =
                        data["total-orders"].total_order;
                    this.dashboard.totalAmount =
                        data["total-orders"].total_order_amount || 0;
                    this.dashboard.totalService =
                        data["total-servicerequests"].servicerequest;
                });
            this.isLoading = false;
        },
        async getAdminAnalyticsData() {
            const keyList = [
                "admin-total-tenants",
                "total-markets",
                "total-users",
                "total-business-plan",
                "total-attributes",
                "total-features",
                "total-subscriptions",
                "total-permission",
                "total-roles",
            ];
            const items = [];
            keyList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {},
                });
            });

            await this.$store
                .dispatch("partner/fetchBulkAnalyticReport", { items: items })
                .then((data) => {
                    this.loading = false;
                    this.adminDashboard.tenantCount =
                        data["admin-total-tenants"].count;
                    this.adminDashboard.totalAttributes =
                        data["total-attributes"].count;
                    this.adminDashboard.totalBusinessPlans =
                        data["total-business-plan"].count;
                    this.adminDashboard.totalFeatures =
                        data["total-features"].count;
                    this.adminDashboard.totalMarkets =
                        data["total-markets"].count;
                    this.adminDashboard.totalSubscriptions =
                        data["total-subscriptions"].count;
                    this.adminDashboard.totalUsers = data["total-users"].count;
                    this.adminDashboard.totalPermissions =
                        data["total-permission"].count;
                    this.adminDashboard.totalRoles = data["total-roles"].count;
                });
        },
        getAnalyticsDataAll() {
            if (this.$userRole === "Tenant" && this.userId) {
                this.getTenantAnalyticsData();
                this.fetchTenantOrderChart();
                this.fetchTopMarketRevenueData();
            } else if (this.$userRole === "Partner" && this.userId) {
                if (this.$currentUserData.category === "SELLER") {
                    this.getSellerDashboardInfo();
                    return;
                } else {
                    this.getDealerDistributorInfo();
                }
            } else if (this.$userRole === "Admin" && this.userId) {
                this.getAdminAnalyticsData();
                this.fetchAdminOrderChart();
            }
        },
        async fetchTopMarketRevenueData() {
            this.isTopMarketLoading = true;
            const dataList = [
                {
                    key: "top-revenue-market-report",
                    variables: {
                        tenant: this.userId,
                        ...this.getDateInfo(this.selectedDate3.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchTopMarketData", {
                items: dataList,
            });
            this.isTopMarketLoading = false;
        },
        async fetchSellerTopMarketRevenue() {
            this.isTopMarketLoading = true;
            const dataList = [
                {
                    key: "admin-top-revenue-market-report",
                    variables: {
                        ...this.getDateInfo(this.selectedDate3.value),
                        userId: this.userId,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchTopMarketData", {
                items: dataList,
            });
            this.isTopMarketLoading = false;
        },
        async fetchTenantOrderChart() {
            this.isLoading = true;
            const dataList = [
                {
                    key: "total-order-report-graph",
                    variables: {
                        tenant: this.userId,
                        ...this.getDateInfo(this.selectedDate2.value),
                    },
                },
            ];
            const data = await this.$store.dispatch("partner/fetchBulkChart", {
                items: dataList,
            });
            this.isLoading = false;
        },
        getStatusData(statusData) {
            let data = {};
            if (
                statusData.length === 0 ||
                statusData.some((el) => el === "All Status")
            ) {
                this.statusOptions.forEach((el, index) => {
                    if (el !== "All Status") {
                        data[`status${index}`] = el;
                    }
                });
            } else {
                statusData.forEach((el, index) => {
                    data[`status${index + 1}`] = el;
                });
            }
            return data;
        },
        async fetchSellerOrderChart() {
            this.isLoading = true;
            const data = [
                {
                    key: "admin-top-revenue-market-report",
                    variables: {
                        ...this.getDateInfo(this.selectedDate2.value),
                        userId: this.userId,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchBulkChart", {
                items: data,
            });
            this.isLoading = false;
        },
        async fetchAdminOrderChart() {
            this.loading = true;
            let keyString = "orderbyvalue-graph";
            if (this.selectedTenant.text === "All Tenants") {
                keyString = "all-tenants-orderbyvalue-graph";
            }
            const dataList = [
                {
                    key: keyString,
                    variables: {
                        tenant: this.selectedTenant.value,
                        ...this.getDateInfo(this.selectedDate2.value),
                        ...this.getStatusData(this.selectedStatusOptions),
                    },
                },
            ];
            if (this.selectedTenant.text === "All Tenants") {
                delete dataList[0].variables.tenant;
            }
            await this.$store.dispatch("partner/fetchBulkChart", {
                items: dataList,
            });
            this.loading = false;
        },
    },
    async mounted() {
        this.loading = false;
        this.getAnalyticsDataAll();
        if (this.$currentUserData.category === "SELLER" && this.userId) {
            this.fetchSellerTopMarketRevenue();
            this.fetchSellerOrderChart();
        }
        if (this.$userRole === "Admin") {
            this.$store.dispatch("tenant/fetchTenantsList");
        }
    },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
    width: 100% !important;
}

.piechart {
    display: block;
    height: 300px;
    width: 300px;
}

.v-tabs__slider {
    height: 43px;
    width: 100%;
    border-radius: 18px;
    left: 20px;
    margin-top: -8px;
    margin-bottom: 2px;
}

.v-tabs__container {
    background: var(--primary);
    border-radius: 18px;
}

.v-tabs__slider-wrapper {
    bottom: 0;
    margin: 0 !important;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    left: 45px;
    width: 200px;
}

v-tabs__slider-wrapper {
    left: 1px;
    width: 160px;
}

.box-text {
    font-size: 13px;
}

.head-text {
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
}

.v-card.v-sheet.theme--light {
    margin-bottom: 20px;
}
.dashboard-header {
    background: var(--secondary);
    display: flex;
    align-items: center;
    padding: 1rem;
    margin: 0;
}
.dash-text {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0px;
}
.dashboard-drop .form-group {
    margin: 0;
}
</style>
